import React, { useState, useEffect } from "react";
import Header from "../../components/header";
import './main.css';
import SiderBar from "../../components/sidebar";
import { CloseOutlined } from "@mui/icons-material";
import InfoPage from "./component/infoPage";
import CreatePage from "./component/createPage";
import { useRouter } from '../../router/hooks/index';
import { useGlobalContext } from '../../services/GlobalContext';
import Modal from 'react-bootstrap/Modal';
import API_BASE_URL, { Providers } from '../../services/Config';
import axios from 'axios';
import toast from 'react-hot-toast';
import { animalAssets } from '../../services/constant';

import Popover from '@mui/material/Popover';
import Typography from '@mui/material/Typography';

export default function AnimalManagePage() {
    const [sideState, setSideState] = useState(1);
    const { data, setloading } = useGlobalContext();
    const [animalData, setAnimalData] = useState([]);
    const [modalShow, setModalShow] = useState(false);
    const [entitylist, setEntitylist] = useState([]);
    const [entity, setEntity] = useState('');
    const [anchorEl, setAnchorEl] = React.useState(null);
    const router = useRouter();

    const userData = JSON.parse(localStorage.getItem('userData'));
    const provider_id = userData['provider_id'];
    const token = localStorage.getItem('authToken');
    const network_id = localStorage.getItem('network_id');


    const open = Boolean(anchorEl);
    const id = open ? 'simple-popover' : undefined;


    const handleClose = () => {
        setAnchorEl(null);
    };

    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const handleSelect = (item) => {
        localStorage.setItem('entity_id', item.id);
        setEntity(item.name);
        setAnchorEl(null);
    }

    const handleSubmit = () => {
        setModalShow(false);
    }
    useEffect(() => {
        if (data.policies) {
            const newAnimalData = data.policies[0].quote.protected_assets.map((item) => {
                return {
                    name: item.properties[0].data,
                    age: calculateAge(item.properties[3].data),
                    type: getLabel(item.properties[1].data, item.properties[1].options),
                    gender: item.properties[2].data,
                    color: getLabel(item.properties[6].data, item.properties[6].options),
                    breed: getLabel(item.properties[5].data, item.properties[5].options),
                    microchip_number: item.properties[4].data,
                    isActive: 1,
                };
            });

            setAnimalData(newAnimalData);
        }
    }, [data]);

    function calculateAge(birthdate) {
        const today = new Date();
        const birthDate = new Date(birthdate);

        let age = today.getFullYear() - birthDate.getFullYear();
        const monthDiff = today.getMonth() - birthDate.getMonth();

        // If the current month is before the birth month, or it's the birth month but the day hasn't occurred yet, subtract 1 from the age
        if (monthDiff < 0 || (monthDiff === 0 && today.getDate() < birthDate.getDate())) {
            age--;
        }
        return age;
    }

    const getLabel = (value, options) => {
        const option = options.find(option => option.data === value);
        return option ? option.label : "tipo desconhecido";
    };

    const handleHome = () => {
        router.push('/home');
    };

    const checkEntities = async () => {

        await axios.get(`${API_BASE_URL()}/v3/applications/self/${Providers()}/networks/${network_id}/entities?page_size=999&order_by=name`, {
            headers: {
                'Authorization': 'Bearer ' + token,
                'Content-Type': 'application/json',
            }
        }).then((res) => {

            setEntitylist(res.data);
            if (res.data.size > 1)
                setModalShow(true);
            else if (res.data.size === 1) {
                localStorage.setItem('entity_id', res.data.elements[0].id);
                setEntity(res.data.elements[0].name);
            }
        }).catch((err) => {
            toast.error(err);

        })
    }
    useEffect(() => {
        if (entity === '')
            checkEntities();
    }, []);
    return (
        <div className="h--100 w--100">
            <Header entitylist={entitylist} entity={entity} setEntity={setEntity} />
            <div className="animal_manage">
                <SiderBar data={animalData} setSideState={setSideState} sideState={sideState} />
                <div className="manage_content">
                    <div className="manage_title font-20-900">
                        <span>DADOS DA APÓLICE</span>
                        <button className="btn_remove font-13-900 " onClick={handleHome}>
                            FECHAR FICHA <CloseOutlined sx={{ fontSize: '24px' }} />
                        </button>
                    </div>
                    <div className="manage_stage">
                        {sideState === 1 ? (<InfoPage />) : (<CreatePage />)}
                    </div>
                </div>
            </div>
            <Modal
                show={modalShow}
                size="lg"
                aria-labelledby="contained-modal-title-vcenter"
                centered
                style={{ maxWidth: '100%', borderRadius: '1.2rem' }}
            >

                <Modal.Body style={{ height: '500px', display: 'flex', flexDirection: 'column' }}>
                    <span className="font-20-900 font-color" style={{ marginTop: '96px', maxWidth: '290px', alignSelf: 'center' }} >SELECIONE A ENTIDADE COM A QUAL PRETENDE AVANÇAR</span>
                    <button className={`md_list font-13-700  font-left ${entity ? "font-color" : "font-color1"} `} onClick={handleClick}>
                        <span>{entity ? entity : 'Selecionar Entidade...'}</span> <img src={animalAssets.ic_arrow_down} alt="" className="arrow_btn" />
                    </button>
                    <Popover
                        id={id}
                        open={open}
                        anchorEl={anchorEl}
                        onClose={handleClose}
                        anchorOrigin={{
                            vertical: 'bottom',
                            horizontal: 'center',
                        }}
                        transformOrigin={{
                            vertical: 'top',
                            horizontal: 'center',
                        }}
                        sx={{
                            '& .MuiPaper-root': {

                                maxWidth: '27rem',
                                width: '100%',
                                border: '1px solid #fff',
                                borderRadius: '1.1rem',
                                boxShadow: '0px 0px 23px 0px #00000026'
                            },
                        }}
                    >
                        <Typography sx={{ p: 2 }}>
                            <div className="flex flex-col gap-2">

                                {entitylist.elements?.map((item) => (
                                    <button key={item.id} className="common-btn font-13-700 font-color font-left" onClick={() => handleSelect(item)}>{item.name}</button>
                                ))}
                            </div>
                        </Typography>
                    </Popover>
                    <div className="card_button">
                        {
                            entity === '' ?
                                (<button className="btn-primary font-14-700" disabled>CONTINUAR</button>)
                                :
                                (<button className="btn-secondly font-14-700 hover:bg-[#29215B] hover:border-[#29215b]" onClick={() => handleSubmit()}>CONTINUAR</button>)
                        }

                    </div>
                </Modal.Body>
            </Modal>
        </div>
    );
}
